import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import { PlatformHero } from "@/components/platform/PlatformHero";
import { ArchitectureDiagram } from "@/components/platform/ArchitectureDiagram";
import { InfrastructureConsole } from "@/components/platform/InfrastructureConsole";
import { GovernanceJourney } from "@/components/platform/GovernanceJourney";
import { SecurityGrid } from "@/components/platform/SecurityGrid";

export function PlatformPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const topnavHeight = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue("--topnav-height") || "64",
            10,
          );
          const top = el.getBoundingClientRect().top + window.scrollY - topnavHeight - 16;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 100);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <>
      <PageMeta
        title="Platform | COSX"
        description="Infrastructure, governance, and security for AI agents in regulated industries. SSO, billing, data residency, compliance gates, audit trails, and human oversight — built into every layer."
        path="/platform"
      />

      <PlatformHero />

      <ArchitectureDiagram />

      <ScrollSection
        id="infrastructure"
        title="Infrastructure"
        subtitle="The shared services that every agent runs on."
        compact
      >
        <InfrastructureConsole />
      </ScrollSection>

      <ScrollSection
        id="governance"
        title="Governance"
        subtitle="How every AI decision gets tracked, checked, and approved."
        compact
      >
        <GovernanceJourney />
      </ScrollSection>

      <ScrollSection
        id="security"
        title="Security"
        subtitle="Certifications, practices, and commitments."
        compact
      >
        <SecurityGrid />
      </ScrollSection>

      <ScrollSection id="build-with-us" title="Build with us" subtitle="We work with firms in regulated industries that need AI they can trust. Whether you want to deploy one of our agents or build something new on the COSX platform, let's talk." compact>
        <div className="flex flex-wrap gap-4">
          <Link
            to="/contact?interest=platform"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium bg-[var(--color-fg)] text-[var(--color-bg)] hover:opacity-90 transition-opacity"
          >
            Get in touch
          </Link>
          <Link
            to="/products"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium border border-[var(--color-border)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
          >
            View our products →
          </Link>
        </div>
      </ScrollSection>
    </>
  );
}
